<template>
    <div class="page-information SlimContainerWithTopMarginWhiteBg">
        <v-container>
          <div class="page-information__content">
              <download-content-buttons v-if="showPrintContentButton || showDownloadContentButton"
                                        :pagePartId="pagePartId"
                                        :showPrintContentButton="showPrintContentButton"
                                        :showDownloadContentButton="showDownloadContentButton"/>

              <page-parts ref="containerContent" :items="items"/>
          </div>
        </v-container>
    </div>
</template>

<script>
export default {
    name: "SlimContainerWithTopMarginWhiteBg",

    props: ['pagePartId', 'items', 'showPrintContentButton', 'showDownloadContentButton'],
}
</script>

<style lang="sass">
@import "sass/components/pages/wrappers/SlimContainerWithTopMarginWhiteBg"
</style>